import React from 'react';
import './home.css';
import { Navbar, Header, Footer, Hovercard, Homebody, Hero, Metrics } from '../../components';

const Home = () => {
  return (
    <div>
      <Navbar />
      <Header />
      <Hero />
      <Hovercard />
      <Homebody />
      <Metrics />
      <Footer />
    </div>
  )
}

export default Home
